import { $API } from "boot/api";
import { clearItemSales } from "src/store/inventory-reorder/mutations";
import moment from "moment";

export function addItemToReorder({ commit, state, rootState }, itemData) {
  commit("addItem", itemData);

  if (!itemData.is_supplier_registered) {
    let contact = rootState.data.company_contacts.find(
      (c) => c.license_number === itemData.supplier_license_number
    );

    commit("addSupplierInfo", {
      license_number: itemData.supplier_license_number,
      facility_name: itemData.supplier_name,
      first_name: contact?.first_name,
      last_name: contact?.last_name,
      email: contact?.email,
      phone: contact?.phone,
    });
  }

  if (
    typeof state.supplierPaymentTerms[itemData.supplier_license_number] ===
    "undefined"
  ) {
    commit("setSupplierPaymentTerms", {
      license_number: itemData.supplier_license_number,
      value: [],
    });
  }

  let currentLicense = rootState.current.license;

  if (itemData.item.product) {
    $API.PRODUCTS.GET(`${itemData.item.product.id}/inventory`, {
      license: currentLicense?.id,
      inventory_unit: itemData.inventory_unit,
    })
      .then(({ data }) => {
        setItemInventory(commit, state, itemData.item.id, data);
      })
      .catch(() => {});
  } else {
    $API.METRC_ITEM.GET(`${itemData.item.id}/inventory`, {
      license: currentLicense?.id,
      inventory_unit: itemData.inventory_unit,
    })
      .then(({ data }) => {
        setItemInventory(commit, state, itemData.item.id, data);
      })
      .catch(() => {});
  }

  $API.METRC_ITEM.GET(`${itemData.item.id}/sales`, {
    license: currentLicense?.id,
    days: 900, //TODO change to 90 days
  })
    .then(({ data }) => {
      commit("setItemSales", {
        item_id: itemData.item.id,
        sales: data.sales,
      });
    })
    .catch(() => {
      commit("setItemSales", {
        item_id: itemData.item.id,
        sales: [],
      });
    });
}

export function addInventoryRowToReorder({ commit, state, rootState }, data) {
  let rowData = data.row,
    licenseIdsToReorder = data.licenseIds;

  let existingRowIndex = state.inventoryRows.findIndex(
    (row) => row.key === rowData.row_key
  );
  if (existingRowIndex >= 0) {
    commit("removeInventoryRow", existingRowIndex);
  }

  let formDataUnitType = rowData.inventory_unit,
    formDataUnitPrice = rowData.vendor.last_price_per_unit,
    brandName = "";
  if (rowData.type === "product") {
    formDataUnitPrice = rowData.product.target_price;
    formDataUnitType = rowData.product.sold_in_unit;
    brandName = rowData.product.brand.name;
  }
  formDataUnitPrice = parseFloat(formDataUnitPrice).toFixed(2);

  let minQty = 0;
  if (rowData.type === "product" && rowData.product.min_order_qty) {
    minQty = rowData.product.min_order_qty;
  }
  if (["ea", "case"].indexOf(formDataUnitType) < 0) {
    minQty = parseFloat(minQty).toFixed(2);
  } else {
    minQty = Math.round(minQty);
  }

  //Check if has a distributor license.
  const hasDistributor = !!rootState.data.licenses.find(
    (l) => !!l.is_distributor
  );
  const matchingLicenses = rootState.data.licenses
    .filter((l) => (hasDistributor ? !!l.is_distributor : !!l.is_retailer))
    .sort((a, b) => {
      if (!!a.is_central_distribution === !!b.is_central_distribution) {
        return 0;
      }
      return a.is_central_distribution ? -1 : 1;
    });

  commit("addInventoryRow", {
    key: rowData.row_key,
    type: rowData.type,
    product: rowData.product,
    item: rowData.item,
    title: rowData.title,
    brand_name: brandName,
    category_type_name: rowData.category_type?.name,
    strain_name: rowData.strain_name,
    expiration_date: moment.isMoment(rowData.expiration_date)
      ? rowData.expiration_date.format("L")
      : rowData.expiration_date,
    inventory_value: rowData.inventory_value,
    inventory_unit: rowData.inventory_unit,
    unit_type: rowData.unit_type,
    unit_type_full: rowData.unit_type_full,
    supplier: {
      license_number: rowData.vendor.license_number,
      name: rowData.vendor.name,
      is_registered: rowData.vendor.is_registered,
    },
    days_reorder: null,
    hide_not_selected_licenses: licenseIdsToReorder !== null,
    formData: {
      unit_price: formDataUnitPrice,
      inventory_unit: formDataUnitType,
      payment_term_id: null,
      licenses: matchingLicenses.map((l) => ({
        license_id: l.id,
        license_number: l.number,
        facility_name: l.facility.name,
        is_central_distribution: !!l.is_central_distribution,
        // Pre-select based on what was passed, or all available
        is_selected:
          !licenseIdsToReorder || licenseIdsToReorder.indexOf(l.id) >= 0,
        inventory_value: minQty,
        inventory_value_edited: false,
        unit_price: formDataUnitPrice,
        discounts: [],
        notes: "",
        qoh:
          rowData.qoh && typeof rowData.qoh[l.id] !== "undefined"
            ? rowData.qoh[l.id]
            : null,
      })),
    },
    items: rowData.items,
  });

  if (!rowData.vendor.is_registered) {
    let contact = rootState.data.company_contacts.find(
      (c) => c.license_number === rowData.vendor.license_number
    );

    commit("addSupplierInfo", {
      license_number: rowData.vendor.license_number,
      facility_name: rowData.vendor.name,
      first_name:
        contact && contact.contacts.length > 0
          ? contact.contacts[0].first_name
          : "",
      last_name:
        contact && contact.contacts.length > 0
          ? contact.contacts[0].last_name
          : "",
      email:
        contact && contact.contacts.length > 0 ? contact.contacts[0].email : "",
      phone:
        contact && contact.contacts.length > 0 ? contact.contacts[0].phone : "",
    });
  }

  if (
    typeof state.supplierPaymentTerms[rowData.vendor.license_number] ===
    "undefined"
  ) {
    commit("setSupplierPaymentTerms", {
      license_number: rowData.vendor.license_number,
      value: [],
    });
  }

  if (rowData.type === "product") {
    $API.PRODUCTS.GET(`${rowData.product.id}/inventory/vendor`)
      .then(({ data }) => {
        commit("setVendorProductInventory", {
          product_id: rowData.product.id,
          inventory: data,
        });
      })
      .catch(() => {
        commit("setVendorProductInventory", {
          product_id: rowData.product.id,
          inventory: null,
        });
      });
  }

  //Sales are now loaded with items on retailer's page.
  // rowData.items.forEach((metrcItem) => {
  //   matchingLicenses.forEach((license) => {
  //     commit("setItemSales", {
  //       item_id: metrcItem.id,
  //       license_id: license.id,
  //       sales: null,
  //     });
  //   });
  //
  //   $API.METRC_ITEM.GET(`${metrcItem.id}/sales/all`, {
  //     days: 60,
  //     allow_no_price: 1,
  //     for_retailer: true,
  //   })
  //     .then(({ data }) => {
  //       data.all_sales.forEach((salesData) => {
  //         commit("setItemSales", {
  //           item_id: metrcItem.id,
  //           license_id: salesData.license_id,
  //           sales: salesData.sales,
  //         });
  //       });
  //     })
  //     .catch(() => {
  //       matchingLicenses.forEach((license) => {
  //         commit("setItemSales", {
  //           item_id: metrcItem.id,
  //           license_id: license.id,
  //           sales: [],
  //         });
  //       });
  //     });
  //
  //   /*
  //   LOAD items sales for all licenses in a single request ^^^
  //   commit('setItemSales', {
  //     item_id: metrcItem.id,
  //     license_id: metrcItem.license_id,
  //     sales: null
  //   });
  //
  //   $API.METRC_ITEM.GET(`${metrcItem.id}/sales`, {
  //     license: metrcItem.license_id,
  //     days: 60,
  //     allow_no_price: 1
  //   }).then(({data}) => {
  //     commit('setItemSales', {
  //       item_id: metrcItem.id,
  //       license_id: metrcItem.license_id,
  //       sales: data.sales
  //     });
  //   }).catch(() => {
  //     commit('setItemSales', {
  //       item_id: metrcItem.id,
  //       license_id: metrcItem.license_id,
  //       sales: []
  //     });
  //   });
  //   */
  // });
}

function setItemInventory(commit, state, itemId, inventory) {
  let index = state.items.findIndex((i) => i.id === itemId);
  commit("setItemFieldValue", {
    index,
    name: "current_inventory_value",
    value: inventory.inventory_value,
  });
  commit("setItemFieldValue", {
    index,
    name: "current_inventory_unit",
    value: inventory.inventory_unit,
  });
}

export function clearItems({ commit }) {
  commit("clearItems");
}

export function clearAllData({ dispatch, commit }) {
  dispatch("clearItems");
  commit("clearSuppliersInfo");
  commit("clearItemSales");
}

export function removeItemFromReorder({ commit, state }, itemId) {
  let itemIndex = state.items.findIndex((i) => i.id === itemId);
  if (itemIndex >= 0) {
    commit("removeItem", itemIndex);
  }
}

export function setItemNote({ commit, state, rootState }, itemData) {
  let index = state.items.findIndex((i) => i.id === itemData.itemId);
  commit("setItemFieldValue", {
    index,
    name: "note",
    value: itemData.note,
  });
}

export function addBucketProductsToReorder(
  { commit, state, rootState },
  products,
) {
  if (!Array.isArray(products) || !products.length) {
    return;
  }

  const hasDistributor = !!rootState.data.licenses.find(
    (license) => !!license.is_distributor,
  );

  const matchingLicenses = rootState.data.licenses
    .filter((license) =>
      hasDistributor
        ? !!license.is_distributor
        : !!license.is_retailer,
    )
    .sort((a, b) => {
      if (
        !!a.is_central_distribution ===
        !!b.is_central_distribution
      ) {
        return 0;
      }

      return a.is_central_distribution ? -1 : 1;
    });

  products.forEach((product) => {
    if (!product?.id) {
      return;
    }

    const key = `product_${product.id}`;

    const existingRowIndex =
      state.inventoryRows.findIndex(
        (row) => row.key === key,
      );

    if (existingRowIndex >= 0) {
      commit(
        "removeInventoryRow",
        existingRowIndex,
      );
    }

    const unit =
      product.sold_in_unit ||
      product.inventory_unit ||
      "ea";

    const price = Number(
      product.target_price ?? 0,
    ).toFixed(2);

    let minQty =
      Number(product.min_order_qty || 0);

    if (["ea", "case"].includes(unit)) {
      minQty = Math.round(minQty);
    } else {
      minQty = minQty.toFixed(2);
    }

    commit("addInventoryRow", {
      key,
      type: "product",
      product,

      title:
        product.title ||
        product.name ||
        "",

      supplier: {
        license_number:
          product.vendor?.license_number ||
          product.vendor_license_number ||
          "",

        name:
          product.vendor?.name ||
          product.vendor_name ||
          "Vendor",

        is_registered:
          product.vendor?.is_registered ??
          true,
      },

      formData: {
        inventory_unit: unit,
        unit_price: price,

        licenses: matchingLicenses.map(
          (license) => ({
            license_id: license.id,

            license_number:
            license.number,

            facility_name:
              license.facility?.name ||
              "",

            is_central_distribution:
              !!license.is_central_distribution,

            is_selected: true,

            inventory_value:
            minQty,

            unit_price:
            price,

            discounts: [],

            notes: "",
            allocations: [],
          }),
        ),
      },
    });
  });
}
